import {
  companyIdState,
  type CompanyActivityStatus,
} from '../overview/company.state';
import { useCompany } from '../overview/use-company.query';
import { useAtomValue } from 'jotai';

export const useMetadata = () => {
  const companyId = useAtomValue(companyIdState);
  const { data: company } = useCompany(companyId);

  const activityStatus = company?.activityStatus.value?.name
    ? (company?.activityStatus.value?.name as CompanyActivityStatus)
    : null;

  const socialUrlValues = {
    twitterUrl: company?.twitterUrl.value ?? '',
    linkedinUrl: company?.linkedInUrl.value ?? '',
    websiteUrl: company?.website.value ?? '',
  };

  return {
    activityStatus,
    hqLocation: company?.hqLocation,
    socialUrlValues,
  };
};
